<template>
  <div v-if="show" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-[60]">
    <div class="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold text-gray-900">Select Teachers for {{ moduleCode }}</h3>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <div v-for="teacher in teachers" :key="teacher.staffId" 
             class="border rounded-lg p-4 cursor-pointer hover:bg-gray-50 transition-colors duration-200 relative"
             :class="{ 'bg-green-50 border-green-500': isTeacherSelected(teacher) }"
             @click="toggleTeacher(teacher)">
          <div class="flex flex-col items-center space-y-2">
            <div class="w-24 h-24 rounded-full overflow-hidden bg-gray-200">
              <img v-if="teacher.image" :src="teacher.image" :alt="teacher.name" 
                   class="w-full h-full object-cover" />
              <div v-else class="w-full h-full flex items-center justify-center bg-primary text-white text-2xl">
                {{ getInitials(teacher.name) }}
              </div>
            </div>
            <div class="text-center">
              <p class="font-medium text-gray-900">{{ teacher.name }}</p>
              <p class="text-sm text-gray-500">ID: {{ teacher.staffId }}</p>
            </div>
            <svg v-if="isTeacherSelected(teacher)" class="absolute top-2 right-2 w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>
      </div>
      <div class="mt-6 flex justify-end space-x-3">
        <button @click="$emit('close')" 
                class="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">
          Cancel
        </button>
        <button @click="confirmSelection" 
                class="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark"
                :disabled="selectedTeachers.length === 0">
          Confirm Selection
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeacherSelectionModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    moduleCode: {
      type: String,
      required: true
    },
    teachers: {
      type: Array,
      required: true
    },
    initialSelectedTeachers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedTeachers: []
    }
  },
  created() {
    this.selectedTeachers = [...this.initialSelectedTeachers];
  },
  methods: {
    toggleTeacher(teacher) {
      const index = this.selectedTeachers.findIndex(t => t.staffId === teacher.staffId);
      if (index === -1) {
        this.selectedTeachers.push(teacher);
      } else {
        this.selectedTeachers.splice(index, 1);
      }
    },
    isTeacherSelected(teacher) {
      return this.selectedTeachers.some(t => t.staffId === teacher.staffId);
    },
    confirmSelection() {
      this.$emit('select', this.selectedTeachers);
      this.$emit('close');
    },
    getInitials(name) {
      return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase();
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.selectedTeachers = [...this.initialSelectedTeachers];
      }
    }
  }
}
</script>

